var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b(
        {
          staticClass: "day-legend",
          attrs: {
            tabindex: "0",
            "data-trigger": "hover",
            "data-toggle": _vm.dataToogle,
            title: _vm.dataTitle,
            "data-content": _vm.dataContent,
            "data-placement": "bottom",
          },
        },
        "div",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "badge badge-pil badge-primary p-2" }, [
        _vm._v(" " + _vm._s(_vm.badge) + " "),
      ]),
      _vm.withTitle
        ? _c("span", { staticClass: "ml-1" }, [
            _vm._v(_vm._s(_vm.$t("pages.planing-team.overtime.overtimeNight"))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }